/**
 * The signed-in person's query key, as `queryKeys.session` gives it (query-keys.ts reads it from here). Every route
 * guard reads the session, so `services/session.ts` is in the entry the sign-in page loads; it takes its key from this
 * file instead of the whole key factory, which then loads with the signed-in pages that use it.
 */
export const sessionKey = () => ['session'] as const;
